export default "__VITE_ASSET__PfWOCVSv__"